// @ts-nocheck
import React from 'react';
import MuiIconButton, { IconButtonProps } from '@mui/material/IconButton';
import MuiLoadingButton from '@mui/lab/LoadingButton';
import MuiButton, { ButtonProps } from '@mui/material/Button';

interface Props extends ButtonProps {
  isLoading?: boolean;
  icon?: React.ReactNode
  transform?: 'lowercase' | 'capitalize'
}

interface IconProps extends IconButtonProps {
  icon?: React.ReactNode;
}

function joinButtonName(name: string) {
  if (typeof name !== 'string') {
    return 'test';
  }

  return name.split(' ').join('-').toLowerCase();
}

const renderButton = ({ transform, ...props }: Props) => (
  <MuiButton
    {...props}
    {...transform ? {
      sx: {
        textTransform: transform,
      },
    } : {}}
    disableElevation
    data-testid={`${joinButtonName(props.children as string)}-button`}
  >
    {props.children}
  </MuiButton>
);

const renderIconButton = ({ icon, ...props }: IconProps) => (
  <MuiIconButton {...props}>{icon}</MuiIconButton>
);

const renderLoadingButton = ({ isLoading, color, ...props }: Props) => (
  <MuiLoadingButton
    {...props}
    loading={isLoading}
    color={isLoading ? 'neutral' : color}
    disableElevation
    data-testid={`${joinButtonName(props.children as string)}-button`}
    {...(props.startIcon ? { loadingPosition: 'start' } : {})}
  >
    <span>{props.children}</span>
  </MuiLoadingButton>
);

const Button: React.FC<Props> = ({ ...props }) => {
  if (props.icon) {
    return renderIconButton(props);
  }
  // render standard button when no async operations are involved
  if (props.isLoading === undefined) {
    return renderButton(props);
  }

  return renderLoadingButton(props);
};

export default Button;
